import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="datum"
export default class extends Controller {
	static targets = ["zeitpunktSelect", "zeitpunktLabel", "datumDiv", "input", "jahr", "monat"]

	connect() {
		this.updateLabel()
	}

	updateDatum() {
		this.inputTarget.value = `${this.jahrTarget.value}-${this.monatTarget.value}-1`
		this.inputTarget.dispatchEvent(new Event("change"))
	}

	updateZeitpunkt() {
		this.updateLabel()
		if (this.zeitpunktSelectTarget.value == 0) {
			this.updateDatum()
			this.monatTarget.focus()
		} else {
			this.inputTarget.value = this.zeitpunktSelectTarget.selectedOptions[0].dataset.datum
			this.inputTarget.dispatchEvent(new Event("change"))
		}
	}

	// Private Methods

	updateLabel() {
		if (!this.hasZeitpunktSelectTarget) return

		this.zeitpunktLabelTarget.innerHTML = this.zeitpunktSelectTarget.selectedOptions[0].text

		if (this.zeitpunktSelectTarget.value == 0) {
			this.zeitpunktLabelTarget.classList.add("hidden")
			this.datumDivTarget.classList.remove("hidden")
			this.zeitpunktSelectTarget.style.width = "20px"
		} else {
			this.zeitpunktLabelTarget.classList.remove("hidden")
			this.datumDivTarget.classList.add("hidden")
			this.zeitpunktSelectTarget.style.width = this.zeitpunktLabelTarget.offsetWidth + 20 + 4 + "px"
		}
	}
}
